// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const userCreateInAuthSourceDefault = `entra`;
export const userCreateInDisplayNameOneMax = 200;

export const userCreateInPasswordOneMax = 256;

export const userCreateInRolesMax = 6;

export const UserCreateIn = zod.object({
  "auth_source": zod.enum(['local', 'entra']).default(userCreateInAuthSourceDefault),
  "display_name": zod.union([zod.string().max(userCreateInDisplayNameOneMax),zod.null()]).optional(),
  "email": zod.email(),
  "password": zod.union([zod.string().min(1).max(userCreateInPasswordOneMax),zod.null()]).optional(),
  "roles": zod.array(zod.enum(['user', 'access_manager', 'monitor', 'asset_manager', 'industry_manager', 'admin'])).min(1).max(userCreateInRolesMax).default([`user`])
});

export type UserCreateIn = zod.input<typeof UserCreateIn>;
export type UserCreateInOutput = zod.output<typeof UserCreateIn>;
